import Provider from '@/enums/Provider';
import { extractERSProductPaths } from './ersProductPaths';
import { extractIOProductPaths } from './ioProductPaths';
import { extractKBSProductPaths } from './kbsProductPaths';

export function extractProductPaths(
    htmlSource: string,
    provider: Provider
): string[] {
    switch (provider) {
        case Provider.KBS:
            return extractKBSProductPaths(htmlSource);
        case Provider.IO:
            return extractIOProductPaths(htmlSource);
        case Provider.ERS:
            return extractERSProductPaths(htmlSource);
        default:
            return [];
    }
}
